/*global d3, d3plus*/
import template from './estadisticas.html';
import { FormActions } from 'core/services/form';
import estadisticasI18N from 'i18n/estadisticas/es.json';
import { rest } from 'core/api';
import configFile from 'config.json';
import { fechaRenderer } from 'core/util';

export let EstadisticasComponent = {
  templateUrl: template,
  selector: 'estadisticas',
  bindings: {
    translations: '='
  },
  controller: EstadisticasCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(estadisticasI18N).concat(commonsI18N);

EstadisticasCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', '$window', '$scope'
];

function EstadisticasCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter, $window, $scope) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  this.defaultDateFormat = configFile.defaultDateFormat;

  this.mapStateToThis = mapStateToThis.bind(this);
  this.onChangeDate = onChangeDate.bind(this);
  this.generarGrafico = generarGrafico.bind(this);
  this.obtenerDatos = obtenerDatos.bind(this);

  let unsubscribe;

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    this.form();
  };

  function mapStateToThis(state) {
    return { form: state.form };
  }

  this.tiposReportes = [
    {
      value: 'VENTAS_POR_EMPLEADO',
      name: 'Ventas por Empleado'
    },
    {
      value: 'VENTAS_POR_CATEGORIA',
      name: 'Ventas por Categoría'
    }
  ];

  this.localModel = {
    hastaOptions: {},
    desdeOptions: {},
    mostrarGrafico: false,
    tipo: this.tiposReportes[0]
  };

  function onChangeDate() {
    if (this.model) {
      this.localModel.desdeOptions.maxDate = this.model.hasta;
      this.localModel.hastaOptions.minDate = this.model.desde;
    }
  }

  function obtenerDatos() {
    if ($scope.estadisticaForm.$invalid) {
      this.submitted = true;
      return;
    }
    console.log("aca");
    let self = this;
    let data = Object.assign({}, this.model);
    data.tipo = this.localModel.tipo.value;
    console.log("aca 2.5");
    $ngRedux.dispatch(rest.actions.datosGrafico({}, {
      body: JSON.stringify(data)
    }, (err, data) => {
      console.log("aca 2");
      if (!err && data) {
        self.localModel.grafico = data;
        self.generarGrafico();
        console.log("aca 3")
      } else if (err) {
        ngNotify.set(err.message, 'warn');
        console.log("aca 4");
      }
    }));
  }

  function generarGrafico() {
    console.log(this.localModel.grafico);
    this.localModel.mostrarGrafico = true;
    // var grafico = [
    //   { 'requerimiento': 'req1', 'alimento': 'alim1', 'value': 4 },
    //   { 'requerimiento': 'req1', 'alimento': 'alim2', 'value': 8 },
    //   { 'requerimiento': 'req1', 'alimento': 'alim3', 'value': 2 },
    //   { 'requerimiento': 'req2', 'alimento': 'alim1', 'value': 5 },
    //   { 'requerimiento': 'req2', 'alimento': 'alim2', 'value': 4 },
    //   { 'requerimiento': 'req2', 'alimento': 'alim3', 'value': 6 }
    // ];
    let grafico = this.localModel.grafico.data;
    let empleados = this.localModel.grafico.empleados;
    let productos = this.localModel.grafico.productos;
    let categorias = this.localModel.grafico.categorias;

    let width;
    if ($window.innerWidth > 1000) {
      width = 943;
    } else if ($window.innerWidth < 1000) {
      width = 490;
    }

    width = $('.widget-body').width();

    d3.select('#viz > div').remove();
    var defaults = {
      width: width,
      height: 700,
      align: 'center',
      resize: true,
      format: 'es_ES',
      title: {
        value: this.localModel.tipo.name,
        sub: `Del ${fechaRenderer(this.model.fechaDesde)} al ${fechaRenderer(this.model.fechaHasta)}`,
        total: true
      }
    };

    function renderEmpleado(text) {
      let empleado = empleados[text];
      return empleado ? `${empleado.nombre} ${empleado.apellido}` : text;
    }

    function renderCategoria(text) {
      let categoria = categorias[text];
      return categoria ? `${categoria.nombre}` : text;
    }

    function renderProducto(text) {
      let producto = productos[text];
      return producto ? `${producto.nombre}` : text;
    }

    let format = {
      text: function(text, params) {
        if (text === 'valor') {
          return 'Ventas';
        } else if (params.key === 'empleadoId') {
          return renderEmpleado(text);
        } else if (params.key === 'categoriaId') {
          return renderCategoria(text);
        } else if (params.key === 'productoId') {
          return renderProducto(text);
        } else {
          return d3plus.string.title(text, params);
        }
      },
      number: function(number, params) {
        let formatted = d3plus.number.format(number, params);

        if (params.key === 'valor') {
          formatted = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return formatted + ' GS.';
          // } else if (params.key === 'share') {
          //   return d3plus.number.format(number, params);
        } else {
          return formatted;
        }
      }
    };

    if (this.localModel.tipo.value === 'VENTAS_POR_EMPLEADO') {
      grafico.sort((a, b) => {
        if (a.value < b.value) return 1;
        if (a.value > b.value) return -1;
        return 0;
      });

      d3plus.viz()
        .config(defaults)
        .container('#viz')
        .data(grafico)
        .type('pie')
        .id('empleadoId')
        .size('valor')
        .format(format)
        .labels({ 'align': 'left', 'valign': 'top' })
        // .time({
        //   value: 'mes',
        //   solo: 2012
        // })
        .color({ scale: 'category20c' })
        .draw();
    } else if (this.localModel.tipo.value === 'VENTAS_POR_CATEGORIA') {

      d3plus.viz()
        .config(defaults)
        .container('#viz')
        .data(grafico)
        .format(format)
        .id(['clase', 'categoriaId', 'productoId'])
        .size('valor')
        .type('tree_map')
        .labels({ 'align': 'left', 'valign': 'top' })
        .color({ scale: 'category20c' })
        .draw();
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/estadisticas/list/estadisticas.component.js